import React from 'react'
import styled from 'styled-components'

import { AngleDownIcon } from '../../components/Icons/AngleDown'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const Container = ({ children, ...props }) => {
  return <Wrapper {...props}>{children}</Wrapper>
}

const StyledCaption = styled.div`
  font-size: 13px;
  margin-right: 50px;
`

const Caption = ({ page = 1, totalItems = 0, limit = 30, currentItemsCount = 0, getCaptionMessage }) => {
  const firstItemIndex = (page - 1) * limit + 1
  const lastItemIndex = firstItemIndex + currentItemsCount - 1

  return <StyledCaption>{getCaptionMessage(firstItemIndex, lastItemIndex)}</StyledCaption>
}

const Button = styled.div`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  svg {
    fill: ${(props) => (props.disabled ? '#c1c1d2' : '#5d5c70')};
    width: 26px;
    height: 26px;
  }
`

const StyledPrevious = styled(Button)`
  margin-right: 10px;

  svg {
    transform: rotate(90deg);
  }
`

const Previous = ({ page = 1, setPage }) => {
  const hasPrevious = parseInt(page) > 1

  const handleClick = () => {
    if (hasPrevious) {
      setPage(page - 1)
    }
  }

  return (
    <StyledPrevious disabled={!hasPrevious} onClick={handleClick}>
      <AngleDownIcon />
    </StyledPrevious>
  )
}

const StyledNext = styled(Button)`
  margin-left: 10px;

  svg {
    transform: rotate(270deg);
  }
`

const Next = ({ page = 1, totalItems = 0, limit = 30, setPage }) => {
  const hasNext = totalItems > page * limit

  const handleClick = () => {
    if (hasNext) {
      setPage(page + 1)
    }
  }

  return (
    <StyledNext disabled={!hasNext} onClick={handleClick}>
      <AngleDownIcon />
    </StyledNext>
  )
}

export default {
  Container,
  Caption,
  Previous,
  Next
}
